<template>
  <div>
    <p v-bind:class="sliceStyle" class="slice-title" align="center">{{ situationDescriptions.slice.title }}</p>

    <description-card
      v-for="obj in situationDescriptions.descriptions"
      :key="obj.ref"
      :description="obj"
      :edit="edit"
      :themeAbbr="themeAbbr"
      :subThemeRef="subThemeRef"
      :dataType="dataType"
      :printMode="printMode"
    ></description-card>

    <b-button class="defaultButton add-btn" v-if="edit" block @click="showAddElementPopin()">
      <plus-icon title="" /><span v-if="dataType=='OBSERVATIONS'" v-html="$t('views.themeView.sliceColumn.btnAddObservation')"></span><span v-if="dataType=='OBJECTIFICATIONS'" v-html="$t('views.themeView.sliceColumn.btnAddObjectification')"></span>
    </b-button>
  </div>
</template>

<script>
import DescriptionCard from "./DescriptionCard";
import PlusIcon from 'vue-material-design-icons/Plus.vue';

export default {
  name: "SliceColumn",
  components: {
    DescriptionCard,
    PlusIcon
  },
  props: {
    themeAbbr: String,
    situationDescriptions: Object,
    edit: Boolean, // afficher les colonnes en mode edition ou non
    subThemeRef: String, // identifier dans quel sous-thème on se trouve afin de nommer la popin de manière unique
    dataType: String,
    printMode: {
      type: Boolean,
      default: false
    }
  },
  
  data: function() {
    return {
      sliceStyle: "",
    };
  },
  
  created: function() {
    this.updateSliceStyle();
  },

  beforeUpdate: function() {
    this.updateSliceStyle();
  },

  methods: {
    /**
     * Met à jour le style associé à la tranche.
     */
    updateSliceStyle : function() {
      this.sliceStyle = "sliceStyle" + this.situationDescriptions.slice.num;
    },

    showAddElementPopin: function() {
      if (this.dataType == "OBSERVATIONS") {
        this.$store.commit("SET_POPIN", {
          type: "ADD-DESCRIPTION_SITUATION_ELEMENT",
          themeAbbr: this.themeAbbr,
          subThemeRef: this.subThemeRef,
          slice: this.situationDescriptions.slice
        });
      }
      if (this.dataType == "OBJECTIFICATIONS") {
        this.$store.commit("SET_POPIN", {
          type: "ADD-OBJECTIFICATION_ELEMENT",
          themeAbbr: this.themeAbbr,
          slice: this.situationDescriptions.slice
        });
      }

      this.$bvModal.show("addThemeElement");
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"

.add-btn
  text-align: left
  margin: 3px
  width: calc(100% - 5px)

.sliceStyle1
  background-color: $slice-backgroundcolor-1

.sliceStyle2 
  background-color: $slice-backgroundcolor-2

.sliceStyle3 
  background-color: $slice-backgroundcolor-3

.sliceStyle4 
  background-color: $slice-backgroundcolor-4
</style>

